export enum TargetForListOfDrawingsEnum {
  DRAWING_LIBRARY = 'drawing-library',
  PRODUCTION_ORDER = 'production-schedule',
  PRODUCT_CONFIGURATION = 'product-configuration'
}
